import {
  DialogHeader,
  DialogFooter,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "../ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import React, { FC, useState } from "react";
import { useRefresh } from "react-admin";
import { confirmAssingment } from "@/utils/formChange";
import { Button } from "../ui/button";

interface Props {
  id: number;
  selectedValue: any;
  description: string;
  endpoint: string;
  propKey: string;
  dataOptions: any[];
  endpoint2?: string;
  dataProp?: string;  // set a value if dataOptions is a collection of objects. Value should be a key of an object
}

const DialogConfirmCommon: FC<Props> = ({
  id,
  endpoint,
  endpoint2,
  dataOptions,
  selectedValue,
  description,
  propKey,
  dataProp,
}) => {
  const refresh = useRefresh();
  const [openDialog, setOpenDialog] = useState(false);
  const [currSelected, setCurrSelected] = useState<any>("");

  const handleValueChange = (val: string) => {
    setOpenDialog(true);
    setCurrSelected(Number(val));
  };

  return (
    <>
      <Select
        onValueChange={(value: string) => handleValueChange(value)}
        value={currSelected || selectedValue || ''}
      >
        <SelectTrigger className="h-8 w-40 bg-muted italic">
          <SelectValue placeholder="Assign vehicle" />
        </SelectTrigger>
        <SelectContent align="end">
          <SelectItem value="0">
            No assign
          </SelectItem>
          {
            dataOptions.map((item) => (
              <SelectItem key={item?.id || item} value={item?.id || item}>
                {dataProp ? item[dataProp] : item}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
      {openDialog && (
        <div
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <Dialog open={openDialog} onOpenChange={setOpenDialog}>
            <DialogContent
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <DialogHeader>
                <DialogTitle>Confirm</DialogTitle>
                <DialogDescription>{description}</DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <Button variant="outline"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpenDialog(false);
                    setCurrSelected("");
                  }}
                >
                  No
                </Button>
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    confirmAssingment(
                      propKey,
                      currSelected,
                      endpoint,
                      id,
                      refresh,
                      setOpenDialog,
                      endpoint2,
                    );
                  }}
                >
                  Yes
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
      )}
    </>
  );
};

export default DialogConfirmCommon;
